import { render, staticRenderFns } from "./positions.vue?vue&type=template&id=1f1ba6ee&scoped=true&"
import script from "./positions.vue?vue&type=script&lang=js&"
export * from "./positions.vue?vue&type=script&lang=js&"
import style0 from "./positions.vue?vue&type=style&index=0&id=1f1ba6ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ba6ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
